import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useAuth } from '../../hooks/use-auth';
import { useNavigate } from 'react-router-dom';
import { SplashScreen } from '../splash-screen';

const AuthGuard = ({ children }) => {
  const { isAuthenticated, isInitialized } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Redirige vers la page de connexion uniquement quand l'état est connu
    if (isInitialized && !isAuthenticated) {
      const tenant = globalThis.localStorage.getItem('tenant');
      navigate(tenant ? `/${tenant}` : '/', { replace: true });
    }
  }, [isAuthenticated, isInitialized, navigate]);

  // L'auth n'est pas encore initialisée → on attend sans rien afficher
  if (!isInitialized) {
    return <SplashScreen />;
  }

  // Non authentifié → la redirection est en cours via useEffect, on n'affiche rien
  if (!isAuthenticated) {
    return null;
  }

  return <>{children}</>;
};

AuthGuard.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AuthGuard;
